const validateNzbn = (value: string) => {
  const nzbn = value.replace(/ /g, '');
  return nzbn.length === 13;
};

export default validateNzbn;
